export default __webpack_public_path__ + "static/media/email_icon.c7435b31.svg";